import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useDeleteDeclaration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (declarationId: string) => {
      await request({
        path: `declarations/${declarationId}`,
        method: 'DELETE',
        authenticate: true,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarations'] });
      queryClient.invalidateQueries({ queryKey: ['declarations-meta'] });
      toast.success('Successfully deleted the declaration!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error deleting the declaration!');
    },
  });
};
